import styled, { css } from 'styled-components';

export const Content = styled.div`
  height: 96px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #e6eaec;
  user-select: none;
  background: #12171c;
  border-bottom: 1px solid #2c353d;
`;

export const Container = styled.div`
  font-size: 42px;
  color: inherit;
  letter-spacing: 2px;
  cursor: pointer;
  font-weight: bold;
  .text-shadow {
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.13);
  }
`;

export const Item = styled.span`
  color: rgba(230, 234, 236, 0.45);
  transition: color 0.15s ease;
  ${(props) =>
    props.$active &&
    css`
      color: #5cc98a;
    `}
`;
